import React from 'react';
import isFunction from 'lodash/isFunction';

export type UseTimeoutHook = (callback: () => void, delay: number) => void;

/**
 * Timeout hook. Run a callback after delay
 * @param {*} callback
 * @param {*} delay
 */
const useTimeout: UseTimeoutHook = (callback, delay) => {
  const savedCallback = React.useRef<Parameters<UseTimeoutHook>[0]>();

  // Remember the latest callback
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout
  React.useEffect(() => {
    if (savedCallback && isFunction(savedCallback.current)) {
      const id = setTimeout(savedCallback.current, delay);
      return () => clearTimeout(id);
    }
    return () => null;
  }, [delay]);
};

export default useTimeout;
